/**
 * Checks if a string is a valid email address.
 * @param {string} email - The email address to validate.
 * @returns {boolean} - Returns true if the email is valid, otherwise false.
 *
 * allow ! # $ % & ' * + - / = ? ^ _ ` . { | } ~ before @ symbol
 * do not allow consecutive dots or leading/trailing dots
 * domain must contain at least one dot and top-level domain must be at least two characters long
 *
 */

export const isEmail = (email) => {
  const emailRegex = /^(?!\.)(?!.*\.\.)[a-zA-Z0-9!#$%&'*+-/=?^_`.{|}~]+(?<!\.)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};
